import { Component, ViewEncapsulation, OnInit, OnChanges, Input, SimpleChanges, TemplateRef, ChangeDetectionStrategy, ContentChild } from "@angular/core";
import { NpPanelFooterDirective } from "./panel-footer.directive";
import { NpPanelHeaderDirective } from "./panel-header.directive";
import { NpPanelBodyDirective } from "./panel-body.directive";

/**
 * panelç»ä»¶
 * 
 * <example-url>https://stackblitz.com/edit/angular-hmkf7x?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-panel`,
  templateUrl: 'panel.html',
  styleUrls: ['panel.scss'],
  host: {
    'class': 'np-panel-wrapper flex-wrap col-flex',
    // '[style.background-color]': 'bgColor',
    '[style.border-radius.px]': 'panelRadius'
  },
  encapsulation: ViewEncapsulation.None
})

export class NpPanel implements OnInit {
  /**
   * é¢æ¿ä¸»æ é¢
   */
  @Input() title: string = '';
  /**
   * é¢æ¿å¯æ é¢ - å¸¸ç¨äºå¯¹ä¸»æ é¢çè§£éæè¿°ç­ï¼å¨ä¸»æ é¢å³ä¾§å±ç¤ºã
   */
  @Input() subTitle: string = '';
  /**
   * é¢æ¿èæ¯è²
   */
  @Input() bgColor: string = '#fff';
  /**
   * é¢æ¿åè§
   */
  @Input() panelRadius: number = 5;  // unit: px

  @ContentChild(NpPanelHeaderDirective) npPanelHeader: NpPanelHeaderDirective;
  @ContentChild(NpPanelBodyDirective) npPanelBody: NpPanelBodyDirective;
  @ContentChild(NpPanelFooterDirective) npPanelFooter: NpPanelFooterDirective;

  constructor() { }

  ngOnInit() {
  }
}